
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideas/IdeaMessagePage/IdeaMessagePage",
      function () {
        return require("private-next-pages/ideas/IdeaMessagePage/IdeaMessagePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideas/IdeaMessagePage/IdeaMessagePage"])
      });
    }
  